import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Motifs } from 'src/app/entities/motifs.entity/motifs';

@Component({
  selector: 'app-motif-form',
  templateUrl: './motif-form.component.html',
  styleUrls: ['./motif-form.component.css']
})
export class MotifFormComponent implements OnInit {

  constructor() { }
  @Input() motif: Motifs = new Motifs();
  @Output() motifChange: EventEmitter<Motifs> = new EventEmitter();
  @Input() isSubmitted: boolean = false;

  ngOnInit(): void {
  }

  _change(): void {
    this.motifChange.emit(this.motif)
  }

  get isValid(): boolean {
    return this.motif.name.length > 0;
  }

}
